export enum CatContests {
  NationalSalesContest = '43291348-1fa2-4a4b-a070-1abb67893a87',
  Dynamo = 'fd0ab6a4-0ea5-470f-84bd-2e3d02c03301',
  AddOns = '34b80cdc-fd0e-4807-9d1c-aa3c54c93715',
  Challenges = 'c3a9f8e2-6b4d-4a1f-9d72-5e8b7c1a2f90'
}
